<template>
  <div class="payment-waiting">
    <div class="payment-waiting__spinner">
      <div class="payment-waiting__spinner-dot payment-waiting__spinner-dot--1"></div>
      <div class="payment-waiting__spinner-dot payment-waiting__spinner-dot--2"></div>
      <div class="payment-waiting__spinner-dot payment-waiting__spinner-dot--3"></div>
    </div>
    <p class="payment-waiting__text">Очікуємо підтвердження оплати...</p>
    <p v-if="isTakingLong" class="payment-waiting__subtext">Це може зайняти до 2 хвилин</p>
  </div>
</template>

<script>
export default {
  name: 'PaymentWaiting',
  props: {
    pollAttempts: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isTakingLong() {
      return this.pollAttempts >= 5;
    },
  },
};
</script>

<style scoped lang="scss">
.payment-waiting {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  padding: 80px;
  margin: 40px 55px 120px;
  border: 1px solid #E4E4E7;
  border-radius: 16px;
  box-shadow: 0px 1px 2px 0px #0000000F, 0px 1px 3px 0px #0000001A;

  @media (max-width: 550px) {
    padding: 40px;
    margin: 25px 25px 50px;
  }

  &__spinner {
    display: flex;
    gap: 8px;
    margin-bottom: 32px;
  }

  &__spinner-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #007BBB;
    animation: payment-waiting-bounce 1.4s infinite ease-in-out both;

    &--1 {
      animation-delay: -0.32s;
    }

    &--2 {
      animation-delay: -0.16s;
    }

    &--3 {
      animation-delay: 0s;
    }
  }

  &__text {
    font-size: 32px;
    font-weight: 500;
    text-align: center;
    color: #313437;
    margin: 0;

    @media (max-width: 830px) {
      font-size: 28px;
    }

    @media (max-width: 550px) {
      font-size: 22px;
    }

    @media (max-width: 500px) {
      font-size: 18px;
    }

    @media (max-width: 450px) {
      font-size: 16px;
    }
  }

  &__subtext {
    font-size: 16px;
    color: #71717A;
    margin: 16px 0 0;
  }
}

@keyframes payment-waiting-bounce {
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
</style>